import React, { useState, useRef, useEffect } from 'react';
import { MdErrorOutline, MdOutlineCloudDone, MdVerified } from "react-icons/md";
import { RiUploadCloud2Line, RiDeleteBin5Line } from "react-icons/ri";
import { FaRegFileAlt } from "react-icons/fa";
import { IoCloudUpload } from "react-icons/io5";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getSellerBusinessDetails, updateSellerBusinessDetails } from '../../../API/Api';
import SidebarTab from '../../SidebarTab/SidebarTab';
const SellerBusiness = () => {
	const [activeTab, setActiveTab] = useState('other-details');
	const [catalogueFile, setCatalogueFile] = useState(null);
	const [cancelChequeFile, setCancelChequeFile] = useState(null);
	const [msmeFile, setMsmeFile] = useState(null);
	const [panFile, setPanFile] = useState(null);
	const [gstFile, setGstFile] = useState(null);
	const [factoryLicenseFile, setFactoryLicenseFile] = useState(null);
	const [isoFile, setIsoFile] = useState(null);
	const [bisFile, setBisFile] = useState(null);
	const [apiFile, setApiFile] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [userData, setUserData] = useState(null);

	const cancelChequeFileInputRef = useRef(null);
	const msmeFileInputRef = useRef(null);
	const panFileInputRef = useRef(null);
	const gstFileInputRef = useRef(null);
	const factoryLicenseFileInputRef = useRef(null);
	const isoFileInputRef = useRef(null);
	const bisFileInputRef = useRef(null);
	const apiFileInputRef = useRef(null);
	const catalogueFileInputRef = useRef(null);

	const [isEditing, setIsEditing] = useState(false);
	const [formData, setFormData] = useState({
		communication_channels: "Email",
		msme_number: "",
		pan_number: "",
		gst_number: "",
		factory_license_number: "",
		iso_number: "",
		bis_number: "",
		api_number: "",
		bank_name: "",
		account_number: "",
		account_holder_name: "",
		ifsc_code: "",
		cancelled_cheque: "",
		contact_person_phone_number: "",
		pan_certificate: "",
		gst_certificate: "",
		msme_certificate: "",
		factory_license: "",
		iso_certificate: "",
		bis_license: "",
		verified: false
	});

	useEffect(() => {
		const fetchBusinessDetails = async () => {
			try {
				setLoading(true);
				const response = await getSellerBusinessDetails({});
				const userData = response.user;
				setUserData(userData);

				setFormData({
					...formData,
					msme_number: userData.msme_number || "",
					pan_number: userData.pan_card || "",
					gst_number: userData.GSTIN || "",
					factory_license_number: userData.factory_license_number || "",
					iso_number: userData.iso_certificate_number || "",
					bis_number: userData.bis_license_number || "",
					bank_name: userData.bank_name || "",
					account_number: userData.account_number || "",
					account_holder_name: userData.account_holder_name || "",
					ifsc_code: userData.ifsc_code || "",
					cancelled_cheque: userData.cancelled_cheque || "",
					contact_person_phone_number: userData.contact_person_phone_number || "",
					pan_certificate: userData.pan_certificate || "",
					gst_certificate: userData.gst_certificate || "",
					msme_certificate: userData.msme_certificate || "",
					factory_license: userData.factory_license || "",
					iso_certificate: userData.iso_certificate || "",
					bis_license: userData.bis_license || "",
					verified: userData.verified || false
				});

				if (userData.pan_certificate) {
					setPanFile({ name: 'PAN Certificate', path: userData.pan_certificate });
				}
				if (userData.gst_certificate) {
					setGstFile({ name: 'GST Certificate', path: userData.gst_certificate });
				}
				if (userData.msme_certificate) {
					setMsmeFile({ name: 'MSME Certificate', path: userData.msme_certificate });
				}
				if (userData.factory_license) {
					setFactoryLicenseFile({ name: 'Factory License', path: userData.factory_license });
				}
				if (userData.iso_certificate) {
					setIsoFile({ name: 'ISO Certificate', path: userData.iso_certificate });
				}
				if (userData.bis_license) {
					setBisFile({ name: 'BIS License', path: userData.bis_license });
				}
				if (userData.cancelled_cheque) {
					setCancelChequeFile({ name: 'Cancelled Cheque', path: userData.cancelled_cheque });
				}

				setLoading(false);
			} catch (err) {
				setError(err.message || "Failed to fetch business details");
				toast.error(err.message || "Failed to fetch business details");
				setLoading(false);
			}
		};

		fetchBusinessDetails();
	}, []);

	const handleFileChange = (e, fileType) => {
		const file = e.target.files[0];
		if (!file) return;

		switch (fileType) {
			case "cancelledCheque":
				setCancelChequeFile(file);
				setFormData(prev => ({
					...prev,
					cancelled_cheque: file.name
				}));
				break;
			case "msme":
				setMsmeFile(file);
				break;
			case "pan":
				setPanFile(file);
				break;
			case "gst":
				setGstFile(file);
				break;
			case "factoryLicense":
				setFactoryLicenseFile(file);
				break;
			case "iso":
				setIsoFile(file);
				break;
			case "bis":
				setBisFile(file);
				break;
			case "api":
				setApiFile(file);
				break;
			case "catalogue":
				setCatalogueFile(file);
				break;
			default:
				break;
		}
	};

	const handleFileDelete = (fileType) => {
		switch (fileType) {
			case "cancelledCheque":
				setCancelChequeFile(null);
				setFormData(prev => ({
					...prev,
					cancelled_cheque: ''
				}));
				break;
			case "msme":
				setMsmeFile(null);
				break;
			case "pan":
				setPanFile(null);
				break;
			case "gst":
				setGstFile(null);
				break;
			case "factoryLicense":
				setFactoryLicenseFile(null);
				break;
			case "iso":
				setIsoFile(null);
				break;
			case "bis":
				setBisFile(null);
				break;
			case "api":
				setApiFile(null);
				break;
			case "catalogue":
				setCatalogueFile(null);
				break;
			default:
				break;
		}
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...formData,
			[name]: value
		});
	};

	const handleEditClick = () => {
		setIsEditing(true);
	};

	const handleSaveClick = async () => {
		setIsEditing(false);
		try {
			setLoading(true);

			const formDataToSend = new FormData();

			formDataToSend.append('msme_number', formData.msme_number);
			formDataToSend.append('pan_number', formData.pan_number);
			formDataToSend.append('gst_number', formData.gst_number);
			formDataToSend.append('factory_license_number', formData.factory_license_number);
			formDataToSend.append('iso_number', formData.iso_number);
			formDataToSend.append('bis_number', formData.bis_number);
			formDataToSend.append('api_number', formData.api_number);
			formDataToSend.append('bank_name', formData.bank_name);
			formDataToSend.append('account_number', formData.account_number);
			formDataToSend.append('account_holder_name', formData.account_holder_name);
			formDataToSend.append('ifsc_code', formData.ifsc_code);
			formDataToSend.append('contact_person_phone_number', formData.contact_person_phone_number);

			if (cancelChequeFile instanceof File) {
				formDataToSend.append('cancelled_cheque', cancelChequeFile);
			}
			if (panFile instanceof File) {
				formDataToSend.append('pan_certificate', panFile);
			}
			if (gstFile instanceof File) {
				formDataToSend.append('gst_certificate', gstFile);
			}
			if (msmeFile instanceof File) {
				formDataToSend.append('msme_certificate', msmeFile);
			}
			if (factoryLicenseFile instanceof File) {
				formDataToSend.append('factory_license', factoryLicenseFile);
			}
			if (isoFile instanceof File) {
				formDataToSend.append('iso_certificate', isoFile);
			}
			if (bisFile instanceof File) {
				formDataToSend.append('bis_license', bisFile);
			}
			if (apiFile instanceof File) {
				formDataToSend.append('api_certificate', apiFile);
			}
			if (catalogueFile instanceof File) {
				formDataToSend.append('catalogue', catalogueFile);
			}

			const response = await updateSellerBusinessDetails(formDataToSend);

			toast.success("Business details updated successfully!");

			const updatedDetails = await getSellerBusinessDetails({});
			setUserData(updatedDetails.user);

			setFormData({
				...formData,
				msme_number: updatedDetails.user.msme_number || "",
				pan_number: updatedDetails.user.pan_card || "",
				gst_number: updatedDetails.user.GSTIN || "",
				factory_license_number: updatedDetails.user.factory_license_number || "",
				iso_number: updatedDetails.user.iso_certificate_number || "",
				bis_number: updatedDetails.user.bis_license_number || "",
				bank_name: updatedDetails.user.bank_name || "",
				account_number: updatedDetails.user.account_number || "",
				account_holder_name: updatedDetails.user.account_holder_name || "",
				ifsc_code: updatedDetails.user.ifsc_code || "",
				cancelled_cheque: updatedDetails.user.cancelled_cheque || "",
				contact_person_phone_number: updatedDetails.user.contact_person_phone_number || "",
				pan_certificate: updatedDetails.user.pan_certificate || "",
				gst_certificate: updatedDetails.user.gst_certificate || "",
				msme_certificate: updatedDetails.user.msme_certificate || "",
				factory_license: updatedDetails.user.factory_license || "",
				iso_certificate: updatedDetails.user.iso_certificate || "",
				bis_license: updatedDetails.user.bis_license || "",
			});

			if (updatedDetails.user.pan_certificate) {
				setPanFile({ name: 'PAN Certificate', path: updatedDetails.user.pan_certificate });
			}
			if (updatedDetails.user.gst_certificate) {
				setGstFile({ name: 'GST Certificate', path: updatedDetails.user.gst_certificate });
			}
			if (updatedDetails.user.msme_certificate) {
				setMsmeFile({ name: 'MSME Certificate', path: updatedDetails.user.msme_certificate });
			}
			if (updatedDetails.user.factory_license) {
				setFactoryLicenseFile({ name: 'Factory License', path: updatedDetails.user.factory_license });
			}
			if (updatedDetails.user.iso_certificate) {
				setIsoFile({ name: 'ISO Certificate', path: updatedDetails.user.iso_certificate });
			}
			if (updatedDetails.user.bis_license) {
				setBisFile({ name: 'BIS License', path: updatedDetails.user.bis_license });
			}
			if (updatedDetails.user.cancelled_cheque) {
				setCancelChequeFile({ name: 'Cancelled Cheque', path: updatedDetails.user.cancelled_cheque });
			}

		} catch (error) {
			console.error("Failed to save business details:", error);
			toast.error(error.response?.data?.message || error.message || "Failed to update business details");
			setIsEditing(true);
		} finally {
			setLoading(false);
		}
	};

	if (loading) {
		return <div className="loading-container"></div>;
	}

	if (error) {
		return <div className="error-container">Error: {error}</div>;
	}

	return (
		<div className="verification-container">
			<SidebarTab />
			<div className="my-business-container">
				<div className="account-details-header">
					<h2 className="form-title">Business Details</h2>
					<div className="header-buttons">
						{!isEditing ? (
							<button className="edit-button-business" onClick={handleEditClick}>
								Edit Details
							</button>
						) : (
							<>
								<button className="edit-button-business" onClick={() => setIsEditing(false)}>
									Cancel
								</button>
								<button className="save-button-business" onClick={handleSaveClick}>
									Save Details
								</button>
							</>
						)}
					</div>
				</div>

				<div className="business-details-containers">
					{/* First Column */}
					<div className="business-details-columns">
						<div className="inputGroupss">
							<label className='label'>MSME *</label>
							<div className="fileInputWrappers">
								<input
									type="text"
									name="msme_number"
									placeholder="Enter 12-digit MSME Number"
									value={formData.msme_number}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
								<div className="fileUploadArea">
									{(!msmeFile && !formData.msme_certificate) ? (
										<button onClick={() => msmeFileInputRef.current.click()} disabled={!isEditing}>
											<RiUploadCloud2Line /> Upload
										</button>
									) : (
										<div className="fileInfo">
											<div className="fileDetails">
												<FaRegFileAlt />
												<span>{msmeFile?.name || 'MSME Certificate'}</span>
												{formData.verified && <MdVerified className="verified-icon" />}
											</div>
											<div className="file-actions">
												{(msmeFile?.path || formData.msme_certificate) && (
													<a href={msmeFile?.path || formData.msme_certificate} target="_blank" rel="noopener noreferrer">
														View
													</a>
												)}
												<MdOutlineCloudDone className="uploadSuccessIcon" />
												{isEditing && (
													<RiDeleteBin5Line
														className="deleteIcon deleteIconRed"
														onClick={() => handleFileDelete("msme")}
													/>
												)}
											</div>
										</div>
									)}
								</div>
								<input
									type="file"
									ref={msmeFileInputRef}
									style={{ display: 'none' }}
									onChange={(e) => handleFileChange(e, "msme")}
									accept=".pdf,.jpg,.jpeg,.png"
									disabled={!isEditing}
								/>
							</div>
						</div>

						<div className="inputGroupss">
							<label className='label'>PAN of company*</label>
							<div className="fileInputWrappers">
								<input
									type="text"
									name="pan_number"
									placeholder="Enter PAN (AAAAA0000A)"
									value={formData.pan_number}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
								<div className="fileUploadArea">
									{!panFile ? (
										<button onClick={() => panFileInputRef.current.click()} disabled={!isEditing}>
											<RiUploadCloud2Line /> Upload
										</button>
									) : (
										<div className="fileInfo">
											<div className="fileDetails">
												<FaRegFileAlt />
												<span>{panFile.name}</span>
											</div>
											<MdOutlineCloudDone className="uploadSuccessIcon" />
											{isEditing && (
												<RiDeleteBin5Line
													className="deleteIcon deleteIconRed"
													onClick={() => handleFileDelete("pan")}
												/>
											)}
										</div>
									)}
									<input
										type="file"
										ref={panFileInputRef}
										style={{ display: 'none' }}
										onChange={(e) => handleFileChange(e, "pan")}
										accept=".pdf,.jpg,.jpeg,.png"
										disabled={!isEditing}
									/>
								</div>
							</div>
						</div>

						<div className="inputGroupss">
							<label className='label'>GST Certificate*</label>
							<div className="fileInputWrappers">
								<input
									type="text"
									name="gst_number"
									placeholder="Enter GST Number"
									value={formData.gst_number}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
								<div className="fileUploadArea">
									{!gstFile ? (
										<button onClick={() => gstFileInputRef.current.click()} disabled={!isEditing}>
											<RiUploadCloud2Line /> Upload
										</button>
									) : (
										<div className="fileInfo">
											<div className="fileDetails">
												<FaRegFileAlt />
												<span>{gstFile.name}</span>
											</div>
											<MdOutlineCloudDone className="uploadSuccessIcon" />
											{isEditing && (
												<RiDeleteBin5Line
													className="deleteIcon deleteIconRed"
													onClick={() => handleFileDelete("gst")}
												/>
											)}
										</div>
									)}
									<input
										type="file"
										ref={gstFileInputRef}
										style={{ display: 'none' }}
										onChange={(e) => handleFileChange(e, "gst")}
										accept=".pdf,.jpg,.jpeg,.png"
										disabled={!isEditing}
									/>
								</div>
							</div>
						</div>

						<div className="inputGroupss">
							<label className='label'>Factory License*</label>
							<div className="fileInputWrappers">
								<input
									type="text"
									name="factory_license_number"
									placeholder="Enter Factory License Number"
									value={formData.factory_license_number}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
								<div className="fileUploadArea">
									{!factoryLicenseFile ? (
										<button onClick={() => factoryLicenseFileInputRef.current.click()} disabled={!isEditing}>
											<RiUploadCloud2Line /> Upload
										</button>
									) : (
										<div className="fileInfo">
											<div className="fileDetails">
												<FaRegFileAlt />
												<span>{factoryLicenseFile.name}</span>
											</div>
											<MdOutlineCloudDone className="uploadSuccessIcon" />
											{isEditing && (
												<RiDeleteBin5Line
													className="deleteIcon deleteIconRed"
													onClick={() => handleFileDelete("factoryLicense")}
												/>
											)}
										</div>
									)}
									<input
										type="file"
										ref={factoryLicenseFileInputRef}
										style={{ display: 'none' }}
										onChange={(e) => handleFileChange(e, "factoryLicense")}
										accept=".pdf,.jpg,.jpeg,.png"
										disabled={!isEditing}
									/>
								</div>
							</div>
						</div>

						<div className="inputGroupss">
							<label className='label'>ISO certificate*</label>
							<div className="fileInputWrappers">
								<input
									type="text"
									name="iso_number"
									placeholder="Enter ISO Certificate Number"
									value={formData.iso_number}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
								<div className="fileUploadArea">
									{!isoFile ? (
										<button onClick={() => isoFileInputRef.current.click()} disabled={!isEditing}>
											<RiUploadCloud2Line /> Upload
										</button>
									) : (
										<div className="fileInfo">
											<div className="fileDetails">
												<FaRegFileAlt />
												<span>{isoFile.name}</span>
											</div>
											<MdOutlineCloudDone className="uploadSuccessIcon" />
											{isEditing && (
												<RiDeleteBin5Line
													className="deleteIcon deleteIconRed"
													onClick={() => handleFileDelete("iso")}
												/>
											)}
										</div>
									)}
									<input
										type="file"
										ref={isoFileInputRef}
										style={{ display: 'none' }}
										onChange={(e) => handleFileChange(e, "iso")}
										accept=".pdf,.jpg,.jpeg,.png"
										disabled={!isEditing}
									/>
								</div>
							</div>
						</div>

						<div className="inputGroupss">
							<label className='label'>BIS License</label>
							<div className="fileInputWrappers">
								<input
									type="text"
									name="bis_number"
									placeholder="Enter BIS License Number"
									value={formData.bis_number}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
								<div className="fileUploadArea">
									{!bisFile ? (
										<button onClick={() => bisFileInputRef.current.click()} disabled={!isEditing}>
											<RiUploadCloud2Line /> Upload
										</button>
									) : (
										<div className="fileInfo">
											<div className="fileDetails">
												<FaRegFileAlt />
												<span>{bisFile.name}</span>
											</div>
											<MdOutlineCloudDone className="uploadSuccessIcon" />
											{isEditing && (
												<RiDeleteBin5Line
													className="deleteIcon deleteIconRed"
													onClick={() => handleFileDelete("bis")}
												/>
											)}
										</div>
									)}
									<input
										type="file"
										ref={bisFileInputRef}
										style={{ display: 'none' }}
										onChange={(e) => handleFileChange(e, "bis")}
										accept=".pdf,.jpg,.jpeg,.png"
										disabled={!isEditing}
									/>
								</div>
							</div>
						</div>
					</div>

					{/* Second Column */}
					<div className="business-details-columns">
						<div className="inputGroupss">
							<label className='label'>API certificate*</label>
							<div className="fileInputWrappers">
								<input
									type="text"
									name="api_number"
									placeholder="Enter API Certificate Number"
									value={formData.api_number}
									onChange={handleInputChange}
									disabled={!isEditing}
								/>
								<div className="fileUploadArea">
									{!apiFile ? (
										<button onClick={() => apiFileInputRef.current.click()} disabled={!isEditing}>
											<RiUploadCloud2Line /> Upload
										</button>
									) : (
										<div className="fileInfo">
											<div className="fileDetails">
												<FaRegFileAlt />
												<span>{apiFile.name}</span>
											</div>
											<MdOutlineCloudDone className="uploadSuccessIcon" />
											{isEditing && (
												<RiDeleteBin5Line
													className="deleteIcon deleteIconRed"
													onClick={() => handleFileDelete("api")}
												/>
											)}
										</div>
									)}
									<input
										type="file"
										ref={apiFileInputRef}
										style={{ display: 'none' }}
										onChange={(e) => handleFileChange(e, "api")}
										accept=".pdf,.jpg,.jpeg,.png"
										disabled={!isEditing}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="business-details-sections">
					<div className="other-details-sections">
						<div className="other-contact-header">
							<h1 className='form-title'>Bank Details</h1>
						</div>

						{activeTab === 'other-details' && (
							<div className="form-group">
								<div className="bank-name">
									<label className="label">
										Bank Name
										<MdErrorOutline className="error-icon" />
									</label>
									<input
										type="text"
										name="bank_name"
										className="input-field"
										value={formData.bank_name || ''}
										onChange={handleInputChange}
										disabled={!isEditing}
									/>
								</div>
								<div className="account-name">
									<label className="label">
										Account Number
										<MdErrorOutline className="error-icon" />
									</label>
									<input
										type="text"
										name="account_number"
										className="input-field"
										value={formData.account_number || ''}
										onChange={handleInputChange}
										disabled={!isEditing}
									/>
								</div>
								<div className="account-holder-name">
									<label className="label">
										Account Holder Name
										<MdErrorOutline className="error-icon" />
									</label>
									<input
										type="text"
										name="account_holder_name"
										className="input-field"
										value={formData.account_holder_name || ''}
										onChange={handleInputChange}
										disabled={!isEditing}
									/>
								</div>
								<div className="ifsc-name">
									<label className="label">
										IFSC Code
										<MdErrorOutline className="error-icon" />
									</label>
									<input
										type="text"
										name="ifsc_code"
										className="input-field"
										value={formData.ifsc_code || ''}
										onChange={handleInputChange}
										disabled={!isEditing}
									/>
								</div>
								<div className="cheque-name">
									<label className="label">
										Cancelled Cheque
										<MdErrorOutline className="error-icon" />
									</label>
									<div className="input-wrapper">
										<input
											type="text"
											className="input-field"
											value={formData.cancelled_cheque || ''}
											onChange={handleInputChange}
											disabled
										/>
										{cancelChequeFile ? (
											<div className="fileInfo">
												<FaRegFileAlt />
												<span>{cancelChequeFile.name}</span>
												<MdOutlineCloudDone className="uploadSuccessIcon" />
												{isEditing && (
													<RiDeleteBin5Line
														className="delete-icon"
														onClick={() => handleFileDelete("cancelledCheque")}
													/>
												)}
											</div>
										) : (
											<>
												<button
													className="upload-button"
													onClick={() => cancelChequeFileInputRef.current.click()}
													disabled={!isEditing}
												>
													<RiUploadCloud2Line /> Upload
												</button>
												<input
													type="file"
													ref={cancelChequeFileInputRef}
													style={{ display: 'none' }}
													onChange={(e) => handleFileChange(e, "cancelledCheque")}
													accept=".pdf,.jpg,.jpeg,.png"
													disabled={!isEditing}
												/>
											</>
										)}
									</div>
								</div>
							</div>
						)}

						{activeTab === 'contact-persons' && (
							<div className="contact-persons-form">
								<div className="company-name">
									<label className="label">
										Phone Number
										<MdErrorOutline className="error-icon" />
									</label>
									<input
										type="text"
										name="contact_person_phone_number"
										className="input-field"
										value={formData.contact_person_phone_number || ''}
										onChange={handleInputChange}
										disabled={!isEditing}
									/>
								</div>
							</div>
						)}

						<div className="cheque-name">
							<label className="label">
								Upload Catalogue
								<MdErrorOutline className="error-icon" />
							</label>
							<div className="payment-image-section">
								{!catalogueFile ? (
									<div className="payment-upload-box" onClick={() => catalogueFileInputRef.current.click()}>
										<IoCloudUpload size={50} className="upload-icon" />
										<p className="upload-text">Browse Files to Upload</p>
										<p className="upload-format">(Format: JPG, PNG & PDF)</p>
										<input
											type="file"
											ref={catalogueFileInputRef}
											className="payment-file-input"
											accept=".jpg,.png,.pdf"
											onChange={(e) => handleFileChange(e, "catalogue")}
											style={{ display: 'none' }}
											disabled={!isEditing}
										/>
									</div>
								) : (
									<div className="uploaded-file-container">
										<p className="uploaded-file-name">{catalogueFile.name}</p>
										{isEditing && (
											<RiDeleteBin5Line
												size={20}
												className="delete-icon"
												onClick={() => handleFileDelete("catalogue")}
											/>
										)}
									</div>
								)}
							</div>
						</div>

						<button className="saveBtnBsn" onClick={handleSaveClick}>
							SAVE DETAILS
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default SellerBusiness;